import React from 'react';
import { ConnectionType } from '../types';
import { CONNECTION_TYPES, CONNECTION_TYPE_CONFIG } from '../constants';

interface ConnectionTypeSelectorProps {
  selectedType: ConnectionType;
  onTypeChange: (type: ConnectionType) => void;
}

const ConnectionTypeSelector: React.FC<ConnectionTypeSelectorProps> = ({
  selectedType,
  onTypeChange
}) => {
  const config = CONNECTION_TYPE_CONFIG[selectedType];
  
  return (
    <div className="flex items-center gap-2 px-2 py-1 bg-white border border-gray-200 rounded-md">
      <span className="text-xs text-gray-500 font-medium">Type:</span>
      {config?.icon && (
        <span style={{ color: config.color }} className="flex items-center">
          {config.icon}
        </span>
      )}
      <select
        value={selectedType}
        onChange={(e) => onTypeChange(e.target.value as ConnectionType)}
        className="text-xs font-medium text-black bg-transparent border-none outline-none cursor-pointer focus:ring-0"
        title={config?.description || "Connection Type"}
      >
        {CONNECTION_TYPES.map((type) => (
          <option key={type} value={type}>
            {type}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ConnectionTypeSelector;
